import { render } from "./toast-message.vue?vue&type=template&id=1c3f206f"
import script from "./toast-message.vue?vue&type=script&lang=js"
export * from "./toast-message.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/ui-components/src/components/toast/toast-message.vue"]])

export default __exports__